import * as React from 'react';
import { cn } from 'lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, type, ...props }, ref) => {
        return (
            <input
                type={type}
                ref={ref}
                className={cn(
                    'flex h-9 w-full rounded border border-input bg-background px-3 py-1 text-base text-foreground transition-colors duration-fast',
                    'placeholder:text-neutral-400',
                    'file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground',
                    'focus-visible:outline-none focus-visible:border-ring focus-visible:ring-1 focus-visible:ring-ring',
                    'disabled:cursor-not-allowed disabled:bg-neutral-100 disabled:text-neutral-400',
                    'aria-[invalid=true]:border-destructive aria-[invalid=true]:focus-visible:ring-destructive',
                    className
                )}
                {...props}
            />
        );
    }
);
Input.displayName = 'Input';

export { Input };
